import {IOfferModel} from '../../offers/cors/_models'

export const STOCK_REQUEST_STATUSES = ['pending', 'approved', 'rejected'] as const

export type StockRequestStatusCode = typeof STOCK_REQUEST_STATUSES[number]

export type StockRequestStage = 'dp_approval' | 'finance_approval'

export const STOCK_REQUEST_MIN_QUANTITY = 1
export const STOCK_REQUEST_MAX_QUANTITY = 100000
export const STOCK_REQUEST_MAX_ITEMS = 100

export interface IStockRequest {
  request_id: number
  date_added: string
  status_code: StockRequestStatusCode
  status: string | null
  stage: StockRequestStage | null
  stage_label: string | null
  reason: string | null
  decided_at: string | null
  is_new: boolean
  total_items: number
  total_quantity: number
}

export interface IStockRequestItem {
  /** null for a line the backoffice added for a product the supplier has no offer on. */
  product_supplier_id: number | null
  product_id: number
  name: string | null
  model: string | null
  barcode: string | null
  image: string | null
  quantity: number
}

export interface IStockRequestDetails extends IStockRequest {
  items: IStockRequestItem[]
}

export interface IStockRequestListResponse {
  data: IStockRequest[]
  total: number
  page: number
  limit: number
  pages: number
}

export interface IStockRequestListFilters {
  page?: number
  limit?: number
  status?: StockRequestStatusCode | ''
}

export interface IStockRequestItemPayload {
  product_supplier_id: number
  quantity: number
}

export interface ICreateStockRequestPayload {
  items: IStockRequestItemPayload[]
}

export interface ICreateStockRequestResponse {
  message: string
  data: {
    request_id: number
    status_code: StockRequestStatusCode
    status: string
  }
}

export interface IStockRequestErrorResponse {
  message?: string
  error?: Record<string, string>
}

export interface ISelectedStockItem {
  offer: IOfferModel
  quantity: string
  touched: boolean
  serverError: string | null
}

export const isStockRequestStatus = (value: string | null): value is StockRequestStatusCode =>
  !!value && (STOCK_REQUEST_STATUSES as readonly string[]).includes(value)

export const isValidStockQuantity = (value: string): boolean => {
  if (!/^\d+$/.test(value.trim())) return false
  const n = Number(value)
  return n >= STOCK_REQUEST_MIN_QUANTITY && n <= STOCK_REQUEST_MAX_QUANTITY
}
